import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-botl-2",
  "use": "icon-si-glyph-botl-2-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-botl-2\" id=\"icon-si-glyph-botl-2\"><title>987</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(6.000000, 0.000000)\" fill=\"#434343\"><rect x=\"2\" y=\"0\" width=\"1.96875\" height=\"2.03039551\" class=\"si-glyph-fill\" /><path d=\"M3.88551428,3 L2.06063001,3 C2.06063001,3 2.55752512,4.24666203 0.948966919,5.00601152 C-0.309021113,5.59931659 5.08069142e-11,5.25912801 5.08069142e-11,7.20306271 L5.08069142e-11,14.9004619 C5.08069142e-11,15.5079415 0.521282601,16 1.16043807,16 L4.83854578,16 C5.47973354,16 6,15.5079415 6,14.9004619 L6,7.20306271 C5.99898385,5.17408087 6.18708366,5.76738594 5.02969403,5.03739796 C3.50547589,4.07859267 3.88551428,3 3.88551428,3 Z M5,15 L4,15 L4,7 L5,7 L5,15 L5,15 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-botl-2.svg
// module id = v/jO
// module chunks = 62